<template>
  <div class="callback">Loading...</div>
</template>

<script>
import { AuthService } from "@/services/business/AuthService";
import { useAnnouncementStore } from "@/stores/AnnouncementStore";

export default {
  methods: {
    async handleOAuth2Callback() {
      const query = this.$route.query;

      if (query.code !== undefined) {
        await AuthService.getInstance().handleOAuth2Callback(
          query.code,
          query.state,
        );
      }

      // App.vue skips this route, so resolve here now that the user is authenticated
      useAnnouncementStore().resolveActiveAnnouncement();

      await this.$router.push("/home");
    }
  },
  mounted() {
    this.handleOAuth2Callback();
  },
};
</script>
